// Payload de « Relancer la demande » : une nouvelle intervention REOPEN qui
// reprend l'intervention annulée. FIX-929 — `reopen_origin_course_id` permet à
// l'API de lire l'intervention d'origine en base (appartenance au client,
// facturation partenaire) au lieu de se fier aux champs recopiés.
const buildReopenPayload = (course, slots, version) => {
  const payload = {
    client: { id: course.client_id },
    date: course.date,
    available_min: course.available_min,
    available_max: course.available_max,
    position: course.position,
    status: '',
    paiement: course.paiement,
    course_details: course.course_details,
    bike_details: course.bike_details,
    enregistrement_type: 'REOPEN',
    reopen_origin_course_id: course.id,
    company_id: course.company_id,
    product_id: course.product_id,
    codepromo: course.codepromo,
    pm_id: course.pm_id,
    capabilities: course.capabilities,
    slots,
    version,
  };

  if (course.fixer && course.fixer.shop_id) {
    payload.shop_id = course.fixer.shop_id;
  }

  return payload;
};

export default buildReopenPayload;
